/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { OutcomeRequestBuilderRequestsMetadata, type OutcomeRequestBuilder } from './outcome/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/data-imports/suggest-mappings/{runId}
 */
export interface WithRunItemRequestBuilder extends BaseRequestBuilder<WithRunItemRequestBuilder> {
    /**
     * The outcome property
     */
    get outcome(): OutcomeRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const WithRunItemRequestBuilderUriTemplate = "{+baseurl}/api/data-imports/suggest-mappings/{runId}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const WithRunItemRequestBuilderNavigationMetadata: Record<Exclude<keyof WithRunItemRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    outcome: {
        requestsMetadata: OutcomeRequestBuilderRequestsMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
